import styled from '@emotion/styled'
import {theme} from '../../core/theme'

const BORDER = theme.palette.thryv.borderAlt

export const SwitchRoleWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${theme.space[1.5]};
  width: 100%;
`

export const SwitchRoleLabel = styled.span`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.semibold};
  color: ${theme.colors.text.primary};
`

// `&&` keeps these ahead of global button resets (see PrimaryAction).
export const SwitchRoleTrigger = styled.button`
  && {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space[2]};
    width: 100%;
    height: 32px;
    padding: 0 ${theme.space[3]};
    border: 1px solid ${({open}) => (open ? theme.palette.thryv.blue : BORDER)};
    border-radius: ${theme.radii.lg2};
    background-color: ${theme.palette.neutral[0]};
    color: ${theme.colors.text.primary};
    font-family: inherit;
    font-size: ${theme.fontSizes.md};
    font-weight: ${theme.fontWeights.medium};
    cursor: pointer;
    transition: border-color 0.15s ease;

    &:hover {
      border-color: ${theme.palette.thryv.blue};
    }

    &:focus-visible {
      outline: none;
      box-shadow: ${theme.shadows.focus};
    }
  }

  svg {
    flex-shrink: 0;
    color: ${theme.palette.thryv.blue};
    transform: rotate(${({open}) => (open ? '180deg' : '0deg')});
    transition: transform 0.15s ease;
  }
`

export const SwitchRoleList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 101;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: ${theme.space[1]} 0 0;
  padding: ${theme.space[1]};
  list-style: none;
  background: ${theme.palette.neutral[0]};
  border: 1px solid ${BORDER};
  border-radius: ${theme.radii.lg2};
  box-shadow: 0 8px 24px rgba(61, 81, 153, 0.16);
`

export const SwitchRoleItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.space[2]} ${theme.space[3]};
  border-radius: ${theme.radii.md};
  font-size: ${theme.fontSizes.md};
  font-weight: ${({active}) =>
    active ? theme.fontWeights.semibold : theme.fontWeights.regular};
  color: ${({active}) =>
    active ? theme.palette.thryv.blue : theme.colors.text.primary};
  background: ${({active}) => (active ? '#eef0ff' : 'transparent')};
  cursor: pointer;

  &:hover {
    background: ${theme.palette.thryv.bg};
  }
`
